import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import { DataDisplay } from '@/components/show/data-display';
import { useOrder } from '@/modules/order/application/order';
import { convertNumberToCurrency } from '@/utility/helper/common';
import { Button, Typography, useSnackbar } from '@rrexpress/core';
import { useForm } from '@refinedev/react-hook-form';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

export function ParcelForm(props: {
  onAddPackage: (data: Package) => void, // TODO: any
  onCancel: () => void,
  destinationId: string,
  originId: string,
  availableService: [],
  record?: Package,
}) {
  const [isAddItem, setIsAddItem] = useState(false);
  const [forceRenderCount, setForceRenderCount] = useState(0);

  const userLoginData = JSON.parse(Cookies.get('user_login') as string);
  const form = useForm();
  const {
    handleSubmit, watch, setValue, getValues, reset, ...restUseFormInstance
  } = form;
  const { calculateParcelPrice } = useOrder();
  const { show } = useSnackbar();

  const handleCalculateSummary = async () => {
    try {
      const res = await calculateParcelPrice({
        customer_id: userLoginData.tenantId,
        origin_id: props.originId,
        destination_id: props.destinationId,
        product_service_code: getValues('product_service_code'),
        is_insurance: getValues('is_insurance'),
        parcel_value: +getValues('parcel_value'),
        weight: +getValues('parcel_weight'),
      });

      const data: CalculateParcelPriceResponse = res?.data?.data || {};

      if (data) {
        setValue('parcel_value', +data.parcel_value || null);
        setValue('parcel_weight', +data.weight);
        setValue('insurance_fee', data.insurance_fee);
        setValue('is_insurance', data.is_insurance);
        setValue('discount_amount', data.total_shipping_price_discount_amount);
        setValue('shipping_price', data.total_shipping_price_before_discount);
        setValue('price', data.shipping_price_unit_before_discount);
        setValue('price_subtotal', data.total_shipping_price_before_discount);
        setValue('total_price', data.total_price);
        setValue('route_id', data.route_id);
        setValue('pricelist_id', data.pricelist_id);
        setValue('transport_mode', 'darat');
      }
    } catch (error) {
      show('Harga untuk rute ini tidak tersedia', 'error');
    }
  };

  const handleAddParcel = () => {
    const formValues = getValues();
    if (!formValues.total_price) {
      show('Silahkan isi form yang kosong', 'error');
      return;
    }
    if (+formValues.parcel_value >= 0) {
      formValues.parcel_value = +formValues.parcel_value;
    }
    props.onAddPackage(formValues as Package);
  };

  useEffect(() => {
    setForceRenderCount(forceRenderCount + 1);
  }, [props?.record]);

  useEffect(() => {
    if (props?.record !== undefined) {
      setIsAddItem(true);
    }
  }, []);

  useEffect(() => {
    if (watch('product_service_code') && watch('parcel_weight')) {
      handleCalculateSummary();
    }
  }, [watch('product_service_code'), watch('parcel_weight'), watch('parcel_value')]);

  useEffect(() => {
    handleCalculateSummary();
  }, [watch('is_insurance')]);

  return (
    <BaseForm
      onCancel={() => {
        reset();
        props.onCancel();
      }}
      onFinish={handleAddParcel}
      customForm={form}
      initialValue={props?.record}
    >
      <div className="flex gap-x-6 p-3">
        <div className="flex-grow">
          <div className="mb-4">
            <Typography level={5} fontWeight="bold">Detail Paket</Typography>
          </div>
          <div className="flex flex-col gap-y-4">
            <FormField
              id="parcelType"
              name="parcel_type_id"
              label="Jenis Barang"
              component="dropdown"
              componentProps={{
                label: 'Jenis Barang',
                id: 'parcelType',
                options: [
                  { value: 'b17872cd-12ac-4346-b891-fb8a1320f45c', label: 'Pakaian' },
                  { value: 'b17872cd-12ac-4346-b891-fb8a1320f45d', label: 'Elektronik' },
                  { value: 'b17872cd-12ac-4346-b891-fb8a1320f45f', label: 'Dokumen' },
                  { value: 'b17872cd-12ac-4346-b891-fb8a1320f45e', label: 'Other' },
                ],
                onSelected: (record: any) => {
                  setValue('parcel_type_id', record.value);
                  setValue('parcel_type_name', record.label);
                },
                onSelectedOutputKey: 'value',
                required: true,
              }}
            />
            <FormField
              id="description"
              name="parcel_description"
              label="Deskripsi Barang"
              component="textarea"
              componentProps={{
                label: 'Deskripsi Barang',
                rows: 3,
              }}
            />
            <FormField
              id="service"
              name="product_service_id"
              label="Jenis Layanan"
              component="queryfield"
              componentProps={{
                id: 'service',
                label: 'Jenis Layanan',
                dataProviderName: 'masterdata',
                endpoint: 'product-services/mini',
                keyOptionLabel: 'product_service_name',
                keyOptionValue: 'product_service_id',
                onSelected: (record: any) => {
                  const serviceId = props?.availableService?.map(
                    (item: any) => item?.product_service_id,
                  );
                  if (!serviceId?.includes(record?.value)) {
                    show('Maap jenis layanan tidak tersedia untuk rute ini', 'error');
                    setIsAddItem(false);
                  } else {
                    setValue('product_service_name', record.label);
                    setValue('product_service_id', record.value);
                    setValue('product_service_code', record.record?.product_service_code);
                    setValue('pickup_sla', record.record?.pickup_sla);
                    setValue('sla_unit', record.record?.sla_unit);
                    setValue('service_max_weight', record?.record?.max_weight);
                    setIsAddItem(true);
                  }
                },
              }}
            />
            <FormField
              id="weight"
              name="parcel_weight"
              label="Berat (Kg)"
              component="form"
              componentProps={{
                label: 'Berat',
                type: 'number',
                required: true,
              }}
              onChange={(value) => {
                if (value > getValues('service_max_weight')) {
                  setIsAddItem(false);
                } else {
                  setIsAddItem(true);
                }
              }}

            />
            {getValues('service_max_weight') && !isAddItem
              ? <div className="mt-[-15px] text-right text-red-500">
                <sup>Berat Max {getValues('service_max_weight')} KG !!!</sup>
              </div>
              : ''
            }
            <FormField
              id="insurance"
              name="is_insurance"
              component="checkbox"
              componentProps={{
                id: 'insurance',
                label: 'Asuransi',
                checked: props?.record?.is_insurance,
                onChange: (e) => {
                  if (!e.target.checked) {
                    setValue('parcel_value', null);
                  }
                },
              }}
            />
            <FormField
              name="parcel_value"
              label="Harga Barang"
              component="form"
              componentProps={{
                label: 'Harga Barang',
                type: 'number',
              }}
            />
          </div>
        </div>
        <div className="w-[280px] flex-shrink">
          <div className="mb-4">
            <Typography level={5} fontWeight="bold">Rincian Biaya</Typography>
          </div>
          <div className="flex flex-col gap-y-4 mb-4">
            <DataDisplay
              label="Ongkir"
              value={convertNumberToCurrency(getValues('shipping_price') || 0)}
            />
            <DataDisplay
              label="Biaya Asuransi"
              value={convertNumberToCurrency(getValues('insurance_fee') || 0)}
            />
            <DataDisplay
              label="Diskon"
              value={convertNumberToCurrency(getValues('discount_amount') || 0)}
            />
            <DataDisplay
              label="TOTAL"
              value={convertNumberToCurrency(getValues('total_price') || 0)}
            />
          </div>
        </div>
      </div>
    </BaseForm>
  );
}

export default ParcelForm;
